import { get } from "../../http/api";
import { getMediaUrl } from "../../http/media";
import { getProfileDisplayName } from "../../utils/profileDisplayName";


export const fetchSuggestedProfiles = async () => {
  try {

    const res = await get("matches/suggestions");

    if (!res || !res.data) return [];

    return res.data.map(user => ({
      id: user.id,
      name: getProfileDisplayName(user),
      role: capitalizeRole(user.role),
      username: user.username || null,
      sport: user.sport || null,
      position: user.position || null,
      country: user.country || null,
      avatar: user.image
        ? `${getMediaUrl(user.image)}`
        : null
    }));

  } catch (err) {
    console.error("SUGGESTIONS FETCH ERROR", err);
    return [];
  }
};


const capitalizeRole = (role) => {
  if (!role) return "";

  return role.charAt(0).toUpperCase() + role.slice(1);
};
